/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {LEVEL_SET, LEVEL_UPDATED, UPDATE_TO_SAME_LEVEL} from "../utils/constants";
import {navigationToInfo, resetNavigationToOverview} from "../navigation/NavigationActions";
import {LEVEL_FETCH_DATA_SUCCESS, LEVEL_LOADING, LOADING_LEVEL_FAILED} from "../actions/types";
import {saveUser} from "../utils/auth";
import {userLoggedIn} from "../login/LoginAction";
import {clearWorkout} from "../utils/workoutStore";

export function loadingLevelFailed(error) {
    return {
        type: LOADING_LEVEL_FAILED,
        error
    };
}

export function levelLoading(bool) {
    return {
        type: LEVEL_LOADING,
        isLoading: bool
    };
}

export function levelFetchDataSuccess(login) {
    return {
        type: LEVEL_FETCH_DATA_SUCCESS,
        login
    };
}

export function levelFetchData(level) {
    return (dispatch) => {
        dispatch(levelLoading(true));

        post('setLevel', {
            level: level
        })
            .then((setLevelResponse) => {
                if (setLevelResponse.msg === LEVEL_SET || setLevelResponse.msg === LEVEL_UPDATED || setLevelResponse.msg === UPDATE_TO_SAME_LEVEL) {
                    clearWorkout();
                    saveUser(setLevelResponse.user);

                    dispatch(userLoggedIn(setLevelResponse.user)); //notify system that user object has changed
                    dispatch(levelFetchDataSuccess(setLevelResponse.user));
                    dispatch(resetNavigationToOverview());
                    
                }
                dispatch(levelLoading(false));
            })
            .catch((error) => {
                dispatch(loadingLevelFailed(error));
                dispatch(levelLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/level/LevelAction.js